require('./angular-resource');
module.exports = 'ngResource';



//////////////////
// WEBPACK FOOTER
// ./~/@xlts.dev/angular-resource/index.js
// module id = 443
// module chunks = 0